var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.87.17C1.67.17.69 1.15.69 2.34v9.65c0 1.2.98 2.18 2.18 2.18h16.41c1.2 0 2.17-.99 2.17-2.18V2.34c0-1.2-.98-2.17-2.17-2.17H2.87Zm.18 1.44H19.1L11.55 8.2c-.3.26-.64.26-.94 0L3.05 1.61Zm-.9 1.14L7.25 7.2l-5.12 4.78V2.75Zm17.85 0V12l-5.1-4.8L20 2.76Zm-6.2 5.4 4.86 4.57H3.48l4.89-4.57 1.3 1.13c.8.7 2.02.7 2.83 0l1.3-1.13Z","fill":"currentColor"}));
}

Mail.defaultProps = {"fill":"none","viewBox":"0 0 22 15"};

module.exports = Mail;

Mail.default = Mail;
